import { ProgramItem } from '@/widgets/ProgramItem';
import { IDashboardProgramResource } from '@/entities/Dashboard';

interface StudentProgrammesProps {
  programmes: IDashboardProgramResource[];
}

export const StudentProgrammes = ({ programmes }: StudentProgrammesProps) => (
  <div className="flex flex-col gap-y-4">
    <h2 className="text-[32px] font-medium">My programmes</h2>
    <ul className="grid grid-cols-3 gap-4">
      {programmes.map((program) => {
        let user;

        if (program.leadTeacher) {
          user = {
            avatar: null,
            userName: `${program.leadTeacher.lastName} ${program.leadTeacher.firstName}`,
            href: `/staff/${program.leadTeacher.id}`,
          };
        }

        return (
          <li key={program.id}>
            <ProgramItem
              courseItem={{
                typeCourse: program.type,
                title: program.title,
                user,
                href: `/enrollments/${program.enrollmentId}`,
                progress: program.progress,
              }}
            />
          </li>
        );
      })}
    </ul>
  </div>
);
